import React, { useState } from "react";
import { Button, Input, notification } from "antd";
import { CustomModal } from "../common/CustomModal";
import { editCorporate } from "../../Graphs/CorporateGroups/editcorporateusers";

const EditCorporateUser = ({ 
  visible, 
  onClose, 
  userData, 
  onChange, 
  authToken,  
}) => {
  // console.log("User Data: ", authToken);
  
  // State for form data
  const [formData, setFormData] = useState(userData || {});

  // Handle input changes
  const handleChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);
    if (onChange) onChange(updatedData); // Callback to update parent state if needed
  };

  // Handle edit user
  const handleEditAdmin = async () => {

    try {
      const response = await editCorporate(authToken, formData, userData._id);
      if (response.status === 200) {
        notification.success({ message: "User Updated Successfully!" }); 
        onClose(); 
      } else {
        notification.error({
          message: response.message || "Failed to update user.",
        });
      }
    } catch (error) {
      console.error("Error updating user:", error);
      notification.error({ message: "Something went wrong!" });
    }

    onClose();

    setTimeout(() => {
      window.location.reload();
    }, 1000);
    
  };

  return (
    <CustomModal
      width="600px"
      title="Edit User"
      visible={visible}
      onCancel={onClose}
      maskClosable={false}
      destroyOnClose={true}
    >
      {userData ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "4px 0" }}>
          {/* First Name & Last Name */}
          <div style={{ display: "flex", gap: "16px", width: "100%" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155",
                  marginBottom: "6px",
                }}
              >
                First Name
              </label>
              <Input
                value={formData.first_name || ""}
                onChange={(e) => handleChange("first_name", e.target.value)}
                style={{
                  height: "42px",
                  borderRadius: "8px",
                  borderColor: "#cbd5e1",
                  fontSize: "14px",
                  color: "#0f172a",
                  padding: "0 12px",
                }}
              />
            </div>
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155",
                  marginBottom: "6px",
                }}
              >
                Last Name
              </label>
              <Input
                value={formData.last_name || ""}
                onChange={(e) => handleChange("last_name", e.target.value)}
                style={{
                  height: "42px",
                  borderRadius: "8px",
                  borderColor: "#cbd5e1",
                  fontSize: "14px",
                  color: "#0f172a",
                  padding: "0 12px",
                }}
              />
            </div>
          </div>

          {/* Email (Read-only) */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155",
                marginBottom: "6px",
              }}
            >
              Email
            </label>
            <Input
              value={formData.email || ""}
              disabled
              style={{
                height: "42px",
                borderRadius: "8px",
                borderColor: "#e2e8f0",
                backgroundColor: "#f8fafc",
                color: "#64748b",
                fontSize: "14px",
                padding: "0 12px",
              }}
            />
          </div>

          {/* Footer Action Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "28px",
              paddingTop: "16px",
              borderTop: "1px solid #e2e8f0",
            }}
          >
            <Button
              onClick={onClose}
              style={{
                height: "40px",
                padding: "0 22px",
                borderRadius: "8px",
                borderColor: "#cbd5e1",
                color: "#475569",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Close
            </Button>
            <Button
              type="primary"
              onClick={handleEditAdmin}
              style={{
                height: "40px",
                padding: "0 24px",
                borderRadius: "8px",
                background: "#5C6AC4",
                borderColor: "#5C6AC4",
                color: "#ffffff",
                fontWeight: "600",
                fontSize: "14px",
                boxShadow: "0 2px 4px rgba(92, 106, 196, 0.25)",
              }}
            >
              Edit
            </Button>
          </div>
        </div>
      ) : (
        <p style={{ color: "#64748b", margin: 0 }}>No user data available.</p>
      )}
    </CustomModal>
  );
};

export default EditCorporateUser;
